/* eslint-disable max-len */
import React from 'react';

interface CircleIconProps {
	color?: string;
}

const CircleIcon: React.FC<CircleIconProps> = ({color = '#9798A9'}) => {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z" fill={`${color}`}/>
		</svg>

	);
}

export default CircleIcon;
